import { render, staticRenderFns } from "./shortcut-menus-small.vue?vue&type=template&id=401d40e3&scoped=true"
import script from "./shortcut-menus-small.vue?vue&type=script&lang=js"
export * from "./shortcut-menus-small.vue?vue&type=script&lang=js"
import style0 from "./shortcut-menus-small.vue?vue&type=style&index=0&id=401d40e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d40e3",
  null
  
)

export default component.exports